import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

type BrandLogoProps = {
    width?: number | string;
    alt?: string;
};

const LIGHT = {
    mark: '#0B1F3A',
    brass: '#A88952',
    word: '#5A6A80',
};

const DARK = {
    mark: '#E6EDF5',
    brass: '#D4B56A',
    word: '#B8C4D4',
};

/** viewBox size used for CSS aspect-ratio (prevents height:100% collapse). */
const VB_W = 540;
const VB_H = 680;

/** Inline AP SVG wordmark; not a draggable img. Follows MUI palette.mode. */
export function BrandLogo(props: BrandLogoProps) {
    const { width = 220, alt = 'Audit Program' } = props;
    const theme = useTheme();
    const c = theme.palette.mode === 'dark' ? DARK : LIGHT;

    return (
        <Box
            aria-label={alt}
            role="img"
            sx={{
                width,
                // WHY: height:auto + svg height:100% collapses to 0 in some browsers
                aspectRatio: `${VB_W} / ${VB_H}`,
                display: 'block',
                lineHeight: 0,
                userSelect: 'none',
                WebkitUserSelect: 'none',
                pointerEvents: 'none',
                WebkitUserDrag: 'none',
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="230 220 540 680"
                width="100%"
                height="100%"
                focusable="false"
                aria-hidden="true"
                style={{ display: 'block', pointerEvents: 'none' }}
            >
                <rect x="474" y="240" width="52" height="470" fill={c.mark} />
                <polygon points="474,240 292,710 238,710 472,248" fill={c.mark} />
                <rect x="318" y="480" width="157" height="38" fill={c.mark} />
                <path
                    fill={c.mark}
                    fillRule="evenodd"
                    d="M525,240 H648 L718,295 V463 L648,518 H525 Z M530,292 H630 L666,328 V430 L630,466 H530 Z"
                />
                <rect x="298" y="495" width="400" height="5" fill={c.brass} />
                <polygon points="500,734 513,748 500,762 487,748" fill={c.brass} />
                <text
                    x="500"
                    y="820"
                    textAnchor="middle"
                    fill={c.word}
                    fontFamily="Montserrat, Arial, Helvetica, sans-serif"
                    fontWeight={600}
                    fontSize={34}
                    letterSpacing={14}
                >
                    AUDIT PROGRAM
                </text>
                <text
                    x="500"
                    y="868"
                    textAnchor="middle"
                    fill={c.brass}
                    fontFamily="Montserrat, Arial, Helvetica, sans-serif"
                    fontWeight={600}
                    fontSize={15}
                    letterSpacing={8}
                >
                    PRUDENCE · BALANCE
                </text>
            </svg>
        </Box>
    );
}

export default BrandLogo;
